import React, { useState, useEffect } from 'react'
import axios from 'axios'

import Loader from '../../Loader/Loader';
import AchievementCard from './AchievementCard';

import './Achievements.css'
import AchCarousal from './AchCarousal/AchCarousal';

const ACHIEVEMENTS_URL = '/achievements'

function Achievements() {

  const [achievements, setAchievements] = useState('')
  const [sortedFacilities, setSortedAchievements] = useState([])

  useEffect(() => {
    async function getAchievements() {
      try {
        const response = await axios.get(process.env.REACT_APP_DEPT_API + ACHIEVEMENTS_URL);
        setAchievements(response.data);
      } catch (error) {
        console.error(error);
      }
    }
    getAchievements()
  }, [])

  useEffect(() => {
    let sorted = achievements && achievements.sort((a, b) => a.order_no < b.order_no ? -1 : 1)
    setSortedAchievements(sorted)
}, [achievements])

  const imgAch = sortedFacilities && sortedFacilities.filter(x => x.image && x.image.url !== '')
  const noImgAch = sortedFacilities && sortedFacilities.filter(item => !imgAch.includes(item));

  return (
    <div className='achievements'>
      <div className='section__container'>
        <div className='section'>
          <h1 className='section__header'>Achievements</h1>
          <p className='about__p'>
            The Department has always seen the enthusiasm students put into their works, hence we have encouraged the students to nurture their talents, and they have always stood for the well-being of the society and for the goodwill of science. Evermore, we believe in the passion and hardwork the students have put into practice.
          </p>
          <p className='about__p'>
            The accomplishments we made over the years in various Global Events and Challenges are the result of constant support from the Faculty, Alumni, and Staff. Their contributions to this great venture bring us happiness and pride in celebrating these glorious achievements made by our Students over the past years.
          </p>
          {/* <div style={{width: '100%', height: '100%'}}> */}
          <AchCarousal imgAch={imgAch} />
          {/* </div> */}
          <div className='achievements__container'>
            {noImgAch ? noImgAch.map((ach) => (
              <AchievementCard
                key={ach._id}
                id={ach._id}
                date={ach.date_published}
                title={ach.title}
                description={ach.description}
              />
            )) : <Loader color="#AE9142" size={50} />}
          </div>
        </div>

      </div>
    </div>
  )
}

export default Achievements